import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'localizeDate',
    pure: false,
})
export class LocalizeDatePipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(value, options: Intl.DateTimeFormatOptions = {}) {
        return new Intl.DateTimeFormat(this.translate.currentLang, options).format(new Date(value)).replace(/\//g, '-');
    }
}
